import "bootstrap/dist/css/bootstrap.min.css";

import { Container } from "react-bootstrap";
import { useState } from "react";

import MainPage from "./main_page/MainPage.js";
import NavBar from "./main_page/components/Navigation/NavBar.js";
import ScrollToTopButton from "./main_page/components/Navigation/ScrollToTop.js";
import AlertBanner from "./main_page/components/AlertBanner/AlertBanner.js";
import Footer from "./main_page/components/Footer.js";

import search_config from "./assets/data/search_config.json";
import actionBytes from "./assets/data/action_bytes_master.json";


function App() {
  /**
   * Main app component. Contains all of the state variables and event handlers.
   * @param : None
   * @returns: action bytes page application JSX
   */

  // State variables
  const [actionBytesList, setActionBytesList] = useState(actionBytes["action_bytes"]);
  const [focusAreaActionBytes, setFocusAreaActionBytes] = useState(actionBytes["action_bytes"]);
  const [focusArea, setFocusArea] = useState("");
  const [query, setQuery] = useState("");

  // Show all action_bytes and clear searching parameters
  const resetActionBytes = () => {
    /**
     * Function that resets all search filters and the action bytes results on the main page.
     * @param : None
     * @returns: None
     */

    setFocusArea("");
    setFocusAreaActionBytes(actionBytes["action_bytes"]);
    setQuery("");
    setActionBytesList(actionBytes["action_bytes"]);
  };
  
  // Event handlers
  const focusAreaHandler = (selectedFocusArea) => {
    /**
     * Focus area event handler, triggered when a focus area selection is made. Filters the full action bytes array and updates the action bytes list states.
     * @param selectedFocusArea: focus area selection made by the user
     * @returns: None
     */

    // If no focus area specified, then reset the action bytes and query.
    if (!selectedFocusArea) {
      resetActionBytes();
      return;
    }
    
    const filteredList = actionBytes["action_bytes"].filter(actionByte => actionByte["focus_area"] === selectedFocusArea);
    
    setFocusArea(selectedFocusArea);
    setFocusAreaActionBytes(filteredList); // This state variable is used for dynamic text query filtering (allows for inclusivity of the two search filters)
    setQuery("");
    setActionBytesList(filteredList);
  }
  
  const queryHandler = (query) => {
    /**
     * Text search event handler, triggered when the text query is changed in the search bar. Extracts any keywords or phrases, filters the module results, and 
     * updates the query & action bytes list states accordingly.
     * @param query: string object containing the text pattern inputted by the user
     * @returns: None
     */

    // If the query is empty or has leading whitespace w/ no other chars, no text search filtering is performed.
    if (!query.match(/\S/)) {
      focusAreaHandler(focusArea);
      return;
    }
    
    // Split the query based on whether it's a phrase (Regex pattern w/ removal of excess whitespace) or keywords (space b/w words)
    let querySplit;
    const re = /"(.*?)"/g;

    // If a phrase is found in the query, extract it (and any other keywords) and get rid of any un-needed space. Otherwise, extract each of the keywords.
    if (query.match(re)) {
      querySplit = query.split(re).filter(queryElem => 
        (queryElem !== '') && (queryElem !== ' ')
        ).map(queryElem => queryElem.trim());
    } else {
      querySplit = query.split(" ").filter(queryElem => (queryElem !== ''));
    }
    
    // Filter the focus area-specific action bytes list with the configured search fields (case-insensitive)
    const filteredList = focusAreaActionBytes.filter(actionBytes => {
      return querySplit.some(queryElem => 
        search_config["search_fields"].some(field => {
          if (field === "tags") {
            if (!actionBytes[field]) return false;
            const searchArray = Array.isArray(actionBytes[field]) ? actionBytes[field] : [actionBytes[field]];
            const lowerCaseTags = searchArray.map(tag => tag.toLowerCase());
          
            return lowerCaseTags.some(tag => tag.includes(queryElem.toLowerCase()));
          }

          return actionBytes[field].toLowerCase().includes(queryElem.toLowerCase());
        })
      );
    })

    setQuery(query);
    setActionBytesList(filteredList);
  };

  return (
      <div className="App">
        <NavBar/>
        <AlertBanner message="" />
        <Container>
          <MainPage actionBytesList={actionBytesList}
                    focusAreaHandler={focusAreaHandler} 
                    focusArea={focusArea} queryHandler={queryHandler} 
                    query={query} resetActionBytes={resetActionBytes}
          />
          <ScrollToTopButton></ScrollToTopButton>
        </Container>
        <Footer/>
      </div>
  );
}

export default App;
